import { RouteConfig } from "vue-router";
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";


let routePath = '/admin';

const routes: Array<RouteConfig> = [
    {
        path: routePath +"/courses",
        name: "CourseList",
        component: () => import("../views/Learning/Course/CourseList.vue"),
        meta: {
          requireAuth: true, layout: MasterLayout,
        },
    },
        {
        path: routePath +"/courses/add",
        name: "CourseAdd",
        component: () => import("../views/Learning/Course/CourseForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/courses/:id/edit",
        name: "CourseEdit",
        component: () => import("../views/Learning/Course/CourseForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/courses/:id/show",
        name: "CourseShow",
        component: () => import("../views/Learning/Course/CourseShow.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/sections",
        name: "SectionList",
        component: () => import("../views/Learning/Section/SectionList.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/sections/add",
        name: "SectionAdd",
        component: () => import("../views/Learning/Section/SectionForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/sections/:id/edit",
        name: "SectionEdit",
        component: () => import("../views/Learning/Section/SectionForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/sections/:id/show",
        name: "SectionShow",
        component: () => import("../views/Learning/Section/SectionShow.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/lessons",
        name: "LessonList",
        component: () => import("../views/Learning/Lesson/LessonList.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/lessons/add",
        name: "LessonAdd",
        component: () => import("../views/Learning/Lesson/LessonForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/lessons/:id/edit",
        name: "LessonEdit",
        component: () => import("../views/Learning/Lesson/LessonForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/lessons/:id/show",
        name: "LessonShow",
        component: () => import("../views/Learning/Lesson/LessonShow.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/tags",
        name: "TagList",
        component: () => import("../views/Learning/Tag/TagList.vue"),
        meta: {
          requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/tags/add",
        name: "TagAdd",
        component: () => import("../views/Learning/Tag/TagForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/tags/:id/edit",
        name: "TagEdit",
        component: () => import("../views/Learning/Tag/TagForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/tags/:id/show",
        name: "TagShow",
        component: () => import("../views/Learning/Tag/TagShow.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/bundle_packages",
        name: "BundlePackageList",
        component: () => import("../views/Learning/BundlePackage/BundlePackageList.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/bundle_packages/add",
        name: "BundlePackageAdd",
        component: () => import("../views/Learning/BundlePackage/BundlePackageForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/bundle_packages/:id/edit",
        name: "BundlePackageEdit",
        component: () => import("../views/Learning/BundlePackage/BundlePackageForm.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
    {
        path: routePath +"/bundle_packages/:id/show",
        name: "BundlePackageShow",
        component: () => import("../views/Learning/BundlePackage/BundlePackageShow.vue"),
        meta: {
            requireAuth: true, layout: MasterLayout,
        },
    },
];


export default routes;
